import React, { useEffect, useMemo, useState } from "react";

import moment from "moment";
import Lottie from "react-lottie";
import * as animationData from "../../../assets/animation/floatingIcon.json";
import { Button, NewFooter } from "../../../components";
import Announce from "../../../components/atoms/Announce";
import Layout from "../../../components/atoms/Layout";
import Section from "../../../components/atoms/Section";
import Sponsor from "../../../components/atoms/Sponsor";
import BannerSoc from "../../../components/molecules/v2/BannerSoc";
import GallerySoc from "../../../components/molecules/v2/GallerySoc";
import TimelineSoc from "../../../components/molecules/v2/TimelineSoc";
import TrainingCampSoc from "../../../components/molecules/v2/TrainingCampSoc";
import {
  usePageContextFunction,
  usePageContextState,
} from "../../../context/PageContext";
import useWindowSize from "../../../hooks/useWindowSize";
import {
  useFetchEventDetail,
  useFetchGalleryArticle,
  useFetchSection,
  useFetchSocAttribute,
} from "../../../networks";
import { func } from "../../../utils";
import HallOfFameCard from "../HomeDetails/HallOfFameCard";
import {
  FloatingIconWrapper,
  PlayerContainer,
} from "../HomeDetails/HomeDetails.styled";
import { Container } from "./HomePressCon.styled";
import { getStaticImg } from "../../../utils/function";

import BannerPressCon from "../../../components/molecules/v2/BannerPressCon/BannerPressCon";
import { useNavigate } from "react-router-dom";
import Timeline2025 from "../Timeline2025";
import MediaPartner from "../../../components/atoms/MediaPartner";
import Broadcaster from "../../../components/atoms/Broadcaster";
import NewJourneyCarousel from "../../../components/molecules/v2/NewJourneyCarousel";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

const HomePressCon = ({ slug }) => {
  const { size } = useWindowSize();
  const navigate = useNavigate();
  const slugCity = "soc";
  const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

  const isMobileView = (size?.width || 0) <= 768;
  const isSmallScreen = (size?.height || 0) <= 667;
  const [isShowFloating, setIsShowFloating] = useState(true);
  const [navbarShow, setNavbarShow] = useState(false);

  const {
    setPageMode,
    setIdInView,
    setCity,
    setIsLive,
    setVideoUrl,
    setOpenPopUp: toglePopUp,
  } = usePageContextFunction();

  const { idInView } = usePageContextState();
  const { data: dataSectionRaw } = useFetchSection();

  const { data: dataAttributeSoc } = useFetchSocAttribute();

  const dataSection = dataSectionRaw?.data?.data?.sections ?? [];

  const { data: dataGalleryArticle } = useFetchGalleryArticle("soc");
  const dataGalleryRaw = dataGalleryArticle?.data?.data ?? [];

  const trainingCampKV =
    imgPath + dataAttributeSoc?.data?.data?.soc[0]?.background_shadow_kv;
  const trainingCampKVMobile =
    imgPath + dataAttributeSoc?.data?.data?.soc[0]?.background_shadow_kv_mobile;

  const guestStarKV =
    imgPath + dataAttributeSoc?.data?.data?.soc[0]?.key_visual_guest;
  const guestStarKVMobile =
    imgPath + dataAttributeSoc?.data?.data?.soc[0]?.key_visual_guest_mobile;
  const wordingGuest = dataAttributeSoc?.data?.data?.soc[0]?.guest_wording;

  useEffect(() => {
    const element = document.getElementById("announce");
    element.scrollIntoView(false);
    setIdInView("banner");
    setPageMode("slick-scroll");
    setCity("press-con");
  }, []);
  /* Listen to navbar clicked */
  useEffect(() => {
    window.addEventListener("click", handleClickNavbar);

    return () => {
      window.removeEventListener("click", handleClickNavbar);
    };
  }, []);
  const isShowFloat = useMemo(() => {
    return (
      isShowFloating && !idInView?.includes("footer-landing") && !navbarShow
    );
  }, [navbarShow, isShowFloating, idInView]);
  const handleHideFloatingIcon = () => {
    setIsShowFloating(false);
  };
  const handleClickNavbar = (e) => {
    const className = String(e.target.className);

    if (className?.includes("navbar")) {
      setNavbarShow(className?.includes("onOpen"));
      handleHideFloatingIcon();
    }
  };

  const { data: dataEventDetail, refetch: refetchEventDetail } =
    useFetchEventDetail(slugCity);
  const dataEvent = dataEventDetail?.data?.data?.eventDetail ?? {};
  const { event_start_date, event_end_date, video_url, registration_url } =
    dataEvent;
  const startDate = moment(event_start_date);
  const endDate = moment(event_end_date);
  const liveStreaming = React.useMemo(() => {
    const currentDate = moment();
    if (
      !!video_url &&
      currentDate.isSameOrAfter(startDate, "day") &&
      currentDate.isSameOrBefore(endDate, "day")
    ) {
      setIsLive(true);
      setVideoUrl(video_url);
      return {
        isLive: true,
      };
    }

    setIsLive(false);
    setVideoUrl("");
    return { isLive: false };
  }, [video_url]);
  // useEffect(() => {
  //   toglePopUp({
  //     state: true,
  //     classNamePopupParent: "!top-0 top-[16px] !bottom-0 inline",
  //     classNamePopupContent: `md:bg-[#151E29] bg-[#1F2D3D] static max-h-none h-screen rounded-none md:rounded-3xl ${
  //       isMobileView ? "mt-0" : "mt-[72px]"
  //     }`,
  //     classNamePopupContainer:
  //       "md:bg-[#151E29] bg-[#1F2D3D] shadow-none w-[100vw] p-0 rounded-none",
  //     closePosition: !isMobileView ? "outside" : "inside",
  //     iconCloseClassname: "md:top-0 top-[16px] right-[16px] absolute !h-[24px]",
  //     typePopUp: "custom-children",
  //     invertCloseColor: true,
  //     children: <TopStats />,
  //   });
  // }, [isMobileView]);

  return (
    <div
      className="relative !bg-contain"
      style={{
        backgroundPositionY: "auto",
        background: `url(${func.getStaticImg(
          `${
            isMobileView ? "/bg/bg-talent-m.png" : "/bg/bg-full-presscon-d.png"
          }`
        )}) no-repeat`,
      }}
    >
      <Layout
        className="box-wrapper"
        scrollSnapType={"none"}
        overflowY={"unset"}
        height={"100%"}
      >
        <Section
          id="banner"
          height={"auto"}
          //  backgroundColor={"#1F2D3D"}
        >
          <Announce bgColor="#00BCF1" highlightColor="#1F2D3D" />
          {/* <BannerPressCon
            data={dataEvent}
            slug={slugCity}
            isLive={liveStreaming?.isLive}
          /> */}
          <BannerPressCon
            data={dataEvent}
            slug={slugCity}
            isLive={liveStreaming?.isLive}
          />
        </Section>
        <Section id={"banner-intro"}>
          <Container paddingTop={"0px"}>
            <img
              id="bg-intro"
              className={!isMobileView ? "-mt-[20vh]" : ""}
              src={
                isMobileView
                  ? getStaticImg("/bg/pialabyu-whatis-m.png")
                  : getStaticImg("/bg/pialabyu-whatis-d.png")
              }
            />
          </Container>
        </Section>
        <Section
          id={"banner-section2"}
          height={isMobileView ? "90svh" : "120vh"}
          alignItems={"center"}
          padding={"8svh 0 0 0"}
        >
          <div
            className="flex justify-center relative"
            // style={{
            //   background: `url(${getStaticImg(
            //     isMobileView
            //       ? "/bg/bg-plain-presscon-m.png"
            //       : "/bg/section2PressConBg.png"
            //   )})`,
            //   backgroundRepeat: "no-repeat",
            //   backgroundPositionY: isMobileView ? "-100svh" : "center",
            //   width: "100vw",
            //   height: "100vh",
            //   backgroundSize: "cover",
            // }}
          >
            {isMobileView ? (
              <>
                <img
                  id="tile-section2"
                  src={getStaticImg("/bg/banner-presscon-title-m.png")}
                  className="absolute w-[386px]"
                  style={{ top: "calc(-50px)" }} // Adjust this value as needed
                />
                <img
                  id="mobile-section2"
                  className="mt-[60px] absolute h-[500px]"
                  src={getStaticImg(
                    "/illustration/section2PressConItemx-m.png"
                  )}
                />
                <img
                  id="btn-section2-m"
                  onClick={() => navigate("/registrasi")}
                  className="absolute w-[386px] cursor-pointer"
                  src={getStaticImg("/illustration/btn-section2.png")}
                  style={{ top: "calc(530px)" }} // Adjust this value as needed
                />
              </>
            ) : (
              <div className="flex flex-col items-center">
                <img
                  id="tile-section2"
                  className="mt-[100px]"
                  src={getStaticImg("/bg/banner-presscon-title-d.png")}
                />
                <img
                  id="desktop-section2"
                  className="mt-[8px] h-[597px]"
                  src={getStaticImg("/illustration/section2PressConItemx.png")}
                />
                <img
                  onClick={() => navigate("/registrasi")}
                  className="w-[386px] cursor-pointer"
                  src={getStaticImg("/illustration/btn-section2.png")}
                />
              </div>
            )}
          </div>
        </Section>

        <Container id="timeline-presscon">
          <Section
            scrollSnap={"start"}
            id="timeline-presscon"
            alignItems={"center"}
            background={
              "linear-gradient(181deg, rgba(31, 45, 61, 0.00) 0%, #1F2D3D 48.12%)"
            }
            height={isMobileView ? "auto" : "100vh"}
          >
            <Timeline2025 />
          </Section>
        </Container>

        {/* <Container id="journey-presscon">
          <Section
            scrollSnap={"start"}
            id="journey-presscon"
            alignItems={"center"}
            height={isMobileView ? "auto" : "100vh"}
          >
            <NewJourneyCarousel />
          </Section>
        </Container> */}

        <Section
          id="home-detail-content-02"
          height={"auto"}
          backgroundColor={"#1F2D3D"}
          padding={isMobileView ? "inherit" : "10vh 0 10vh 0"}
          className={"!bg-cover !flex !flex-col"}
        >
          {dataSection?.length !== 0 && (
            <>
              {dataSection
                ?.filter((val) => val?.id === 1)
                .map((value, idx) => {
                  if (value?.section_contents?.length === 0) return null;
                  return (
                    <Section
                      id="sponsor"
                      padding={"16px 0px 0px 0px"}
                      className={"!relative"}
                      //backgroundColor={isMobileView ? "#F0F2F9" : "white"}
                      height={"auto"}
                      display={isMobileView ? "inherit" : "flex"}
                    >
                      <img
                        src={func.getStaticImg("/illustration/brush-3.png")}
                        alt="brush"
                        className="absolute left-0 z-10 top-0" // Position at the top
                        style={{
                          transform: "translateY(-40%)", // Move up by 85% of image height
                          maxWidth: "50%",
                          pointerEvents: "none",
                        }}
                      />
                      <img
                        src={func.getStaticImg("/illustration/brush-2.png")}
                        alt="brush"
                        className="absolute right-0 z-10 top-0" // Position at the top
                        style={{
                          transform: "translateY(-40%)", // Move up by 75% of image height
                          maxWidth: "50%",
                          pointerEvents: "none",
                        }}
                      />
                      <Sponsor
                        key={idx}
                        title={value?.section_name}
                        contents={value?.section_contents}
                        titleClassName="text-white"
                      ></Sponsor>
                    </Section>
                  );
                })}
            </>
          )}

          <>
            {dataSection
              ?.filter((val) => val?.id === 3)
              ?.map((value, idx) => {
                if (value?.section_contents?.length === 0) return null;
                return (
                  <Section
                    key={idx}
                    id="sponsor"
                    padding={
                      isMobileView ? "10vh 0px 0px 0px" : "0px 0px 0px 0px"
                    }
                    //backgroundColor={isMobileView ? "#F0F2F9" : "white"}
                    height={isMobileView ? "auto" : "auto"}
                    display={isMobileView ? "inherit" : "flex"}
                    className={!isMobileView ? "w-1/2" : ""} // Make each section take half the width
                  >
                    {value?.id === 3 && (
                      <Broadcaster
                        key={idx}
                        title={value?.section_name}
                        contents={value?.section_contents}
                        titleClassName="text-white"
                        isInline={!isMobileView} // Pass prop to indicate inline display
                      ></Broadcaster>
                    )}
                    {/* {value?.id === 2 ? (
                      <MediaPartner
                        key={idx}
                        title={value?.section_name}
                        contents={value?.section_contents}
                        titleClassName="text-white"
                        isInline={!isMobileView} // Pass prop to indicate inline display
                      ></MediaPartner>
                    ) : (
                      <Broadcaster
                        key={idx}
                        title={value?.section_name}
                        contents={value?.section_contents}
                        titleClassName="text-white"
                        isInline={!isMobileView} // Pass prop to indicate inline display
                      ></Broadcaster>
                    )} */}
                  </Section>
                );
              })}
          </>
        </Section>

        <Container paddingTop={"0px"}>
          <Section
            id={"footer-landing"}
            backgroundColor={"#1F2D3D"}
            scrollSnap={"end"}
            height={"auto"}
          >
            <NewFooter />
          </Section>
        </Container>
        {isShowFloat && (
          <FloatingIconWrapper
            key={isShowFloat}
            style={isShowFloat ? styles.onShow : styles.onHide}
            onClick={() => {
              setIdInView("banner");
              func.scrollTo("footer-landing");
            }}
          >
            <Lottie
              style={{ width: 120, height: 120 }}
              options={{
                animationData: animationData,
              }}
            />
          </FloatingIconWrapper>
        )}
      </Layout>
    </div>
  );
};

const styles = {
  onHide: {
    opacity: 0,
  },
  onShow: {
    opacity: 1,
    transition: "opacity 0.2s linear",
  },
};

export default HomePressCon;
